import { render } from "./CustomSpinner.vue?vue&type=template&id=2d434d0c"
import script from "./CustomSpinner.vue?vue&type=script&lang=js"
export * from "./CustomSpinner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__